import { __decorate, __metadata } from "tslib";
import { makeAutoObservable } from 'mobx';
import { component } from 'tsdi';
import { getClient } from './payment-client';
export * from './payment-client';
export * as dtos from './payment.dtos';
function extractErrorMessage(errorBody, status) {
    const firstError = Array.isArray(errorBody)
        ? errorBody[0]
        : errorBody;
    const message = firstError?.errorMessage ??
        firstError?.message ??
        `Request failed with status ${status}`;
    if (firstError?.traceId) {
        return `${message} (traceId: ${firstError.traceId})`;
    }
    return message;
}
let Api = class Api {
    _endpoint;
    constructor() {
        makeAutoObservable(this);
    }
    setEndpoint(endpoint) {
        this._endpoint = endpoint;
    }
    get client() {
        if (!this._endpoint) {
            throw new Error('[Api] endpoint not set — call setEndpoint() first');
        }
        return getClient(this._endpoint, undefined, (pretend) => pretend.decode(async (response) => {
            if (!response.ok) {
                const errorBody = await response
                    .json()
                    .catch(() => undefined);
                throw new Error(extractErrorMessage(errorBody, response.status));
            }
            if (response.status === 204) {
                return undefined;
            }
            const contentType = response.headers.get('content-type');
            if (contentType?.startsWith('application/json')) {
                return (await response.json());
            }
            return undefined;
        }));
    }
};
Api = __decorate([
    component(),
    __metadata("design:paramtypes", [])
], Api);
export { Api };
